import { BReviewOrderEnum } from '@/types/backend';
export const SSR_REVIEWS_PER_PAGE = 30;
export const REVIEWS_PER_PAGE = 5;
export const INITIAL_REVIEWS_CONTEXT = {
    entity: null,
    reviews: null,
    loadingReviews: false,
    hasResults: false,
    // Translation
    showTranslated: false,
    toggleShowTranslated: null,
    // Pagination
    totalCount: null,
    activePageIndex: 0,
    setActivePageIndex: null,
    // Order
    order: BReviewOrderEnum.CreatedDesc,
    setOrder: null,
    // Occasion Filter
    hasOccasionFilter: false,
    selectedOccasions: null,
    occasionOptions: null,
    setOccasionOptions: null,
    // Experience Filter
    hasExperienceFilter: false,
    selectedExperienceIds: null,
    experienceOptions: null,
    setExperienceOptions: null
};
